import { IUser, TCreateMspAdminResponse } from "@/features/admins/types";
import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

const useCreateMspAdmin = () => {
  return useMutation({
    mutationFn: (payload: Omit<IUser, "profile">) =>
      MyAxios.post<TCreateMspAdminResponse>("/users", payload).then(
        (res) => res.data,
      ),
  });
};

export default useCreateMspAdmin;
